import { hasCachedObject } from "@/services/caching/cachingHelpers";

export const actions = {
  async setCachingStatus(ctx, languages) {
    ctx.commit("setIsCheckingCachedElements", true);

    for (let index in languages) {
      let defaultVideos = Object.values(ctx.state.videos.default);
      let languageVideos = Object.values(ctx.state.videos[languages[index]]);
      let languagePdfs = Object.values(ctx.state.pdfs[languages[index]]);
      let allElements = defaultVideos.concat(languageVideos, languagePdfs);

      await setCacheStatus(ctx, languages[index], allElements);
    }
    ctx.commit("setIsCheckingCachedElements", false);
  }
};

async function setCacheStatus(ctx, language, languageElements) {
  for (let element in languageElements) {
    let storename = languageElements[element].path.includes(".pdf")
      ? "pdfs"
      : "videos";
    let isCached = await hasCachedObject(
      languageElements[element].path,
      storename
    );
    if (!isCached) {
      ctx.commit("setLanguageCached", { language, isCached });
      return;
    }
  }
  ctx.commit("setLanguageCached", { language, isCached: true });
}
